<!--
* UI Name: View Workflow Group
* PIC: 213960
* Modify Date: 2022/10/15
-->
<template>
  <v-card
    class="v-modal-new-window analyzed-dialog analyzed-view-dialog process-detail-panel process-list-container"
  >
    <!-- [S]  Popup title-->
    <v-card-title class="headline white--text" primary-title>
      {{ title }}
    </v-card-title>
    <!-- [S]  Section detail-->
    <v-card-text class="user-data-section">
      <v-form ref="form" style="margin-top: -20px">
        <!-- //04/09/2021 203737 SPKA-63 issue 34 Modify the alignment of the text field and combo box for workflow -->
        <v-row class="ma-0">
          <v-col class="custom-form-control custom-figma-1 pb-0 pt-0 mt-0 pr-0" cols="12" lg="12">
            <v-row>
              <v-col
                class="comm-header-col data-query-section custom-figma-1 pb-0 pt-0 mt-0"
                cols="12"
                lg="9"
                md="9"
              >
                <v-row class="comm-header-col data-query-section pb-0 pt-0 custom-figma-1">
                  <v-col cols="12" sm="3" class="pb-0 pt-0 pl-0">
                    <div class="pl-0 pt-0 pb-0">
                      <v-text-field
                        v-model="formData.procNm"
                        :disabled="isHistory"
                        :label="$t('lbl.processSetup.addProcess.findbyName')"
                        ref="procNm"
                        dense
                        filled
                      ></v-text-field>
                    </div>
                  </v-col>
                  <v-col
                    v-show="$cookies.get('user-admin-yn') === 'Y'"
                    cols="12"
                    sm="2"
                    class="pt-0"
                  >
                    <div class="pl-0 pt-0 pb-0">
                      <v-autocomplete
                        v-model="formData.compId"
                        :menu-props="{ offsetY: true }"
                        :items="compList"
                        :disabled="isHistory"
                        :label="$t('lbl.common.conditionSearch.selectCompany')"
                        ref="compId"
                        dense
                        filled
                      ></v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="7" class="pt-3">
                    <span :style="$vuetify.theme.dark ? '' : 'color: red'"
                      >{{ $t('lbl.workflowGroup.componentNotUse') }}
                    </span>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row> </v-row>
        <div class="d-flex">
          <div class="proc-icon-container">
            <v-tooltip v-if="authCompList.COM.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-comm drag-drawflow"
                  x-small
                  height="30"
                  width="30"
                  color="proc darken-1"
                  draggable="true"
                  v-on="on"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-comm" />
                </v-btn>
              </template>
              <span>Connector</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.MAP.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-mapper"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  ref="btnAddMap"
                  draggable="true"
                  v-on="on"
                  @dragstart="drag($event, 'MAP')"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-mapper" />
                </v-btn>
              </template>
              <span>Mapper</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.CVT.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-converter"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  draggable="true"
                  v-on="on"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-converter" />
                </v-btn>
              </template>
              <span>Converter</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.USR.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isHistory"
                  class="mb-1 mr-1 proc-button-style proc-ucr"
                  x-small
                  color="proc darken-1"
                  height="30"
                  width="30"
                  draggable="true"
                  v-on="on"
                  @dragstart="drag($event, 'USR')"
                >
                  <icon-svg :disabled="isHistory" :size="procIconSize" iconName="proc-usr" />
                </v-btn>
              </template>
              <span>User</span>
            </v-tooltip>
            <v-tooltip v-if="authCompList.DBA.manage" right content-class="tooltip-right">
              <template v-slot:activator="{ on }">
                <v-btn
                  v-if="isAgent"
                  @click="addComponentPK('DBA')"
                  :disabled="!$auth.manage"
                  class="mb-1 mr-1 proc-button-style proc-dsm"
                  x-small
                  height="30"
                  width="30"
                  color="proc darken-1"
                  draggable="true"
                  v-on="on"
                  @dragstart="drag($event, 'DBA')"
                >
                  <icon-svg :disabled="!$auth.manage" :size="procIconSize" iconName="proc-dsm" />
                </v-btn>
              </template>
              <span>DB Adapter</span>
            </v-tooltip>
          </div>

          <div id="drawtest">
            <!-- <div class="expand-collapse">
              <a class="expand-collapse-text mr-3" @click="collapse(false)">{{
                $t("lbl.processSetup.addProcess.expandAll")
              }}</a>
              <a
                class="expand-collapse-text mr-3"
                style="font-size: 20px; text-decoration: none"
                >|</a
              >
              <a class="expand-collapse-text" @click="collapse(true)">{{
                $t("lbl.processSetup.addProcess.collapseAll")
              }}</a>
            </div> -->
            <div id="drawflow">
              <system-progress
                :sysloading="isLoading"
                :sysloadingTitle="sysloadingTitle"
              ></system-progress>
            </div>
          </div>
        </div>
        <!-- [E]  Section detail-->
        <!-- [S]  Button Control-->

        <!-- /**
           * 2021.08.11 203737 SPKA-183 issue 119 Change button function in Workflow Detail screen
        */-->
        <v-divider class="ml-0 mr-0 mt-4 mb-2 divder-popup" inset></v-divider>
        <v-row class="btn-form-control">
          <v-col cols="10" class="text-left pb-0 pt-0"></v-col>
          <v-col cols="2" class="text-right pb-0 pt-0">
            <v-btn class="btn btn-close btn-popup" @click="closeWindow('btn-close')">{{
              $t('btn.common.close')
            }}</v-btn>
          </v-col>
        </v-row>
        <!-- [E]  Button Control-->
      </v-form>
      <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
        <communicationRightLayer
          ref="communicationRightLayer"
          v-if="dialog.type == 'communicationRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.COM.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:752px !important;"
        ></communicationRightLayer>
        <mapperRightLayer
          ref="mapperRightLayer"
          v-if="dialog.type == 'mapperRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.MAP.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:752px !important;"
        ></mapperRightLayer>
        <userRightLayer
          ref="userRightLayer"
          v-if="dialog.type == 'userRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.USR.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:520px !important; height: 100%"
        ></userRightLayer>

        <converterRightLayer
          ref="converterRightLayer"
          v-if="dialog.type == 'converterRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.CVT.manage"
          :manageDBB="authCompList.DBB.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:520px !important; height: 100%"
        ></converterRightLayer>
        <dbAdapterRightLayer
          ref="dbAdapterRightLayer"
          v-if="dialog.type == 'dbAdapterRightLayer'"
          class="custom-dialog mapper-version"
          :closeDialog="removeDialog"
          :dragEnd="dialogDragEnd"
          :dragStart="selectDialog"
          :move="dialogDragEnd"
          :manage="authCompList.DBA.manage"
          :options="dialog.options"
          :id="dialog.id"
          style="position: absolute;right:0;top:0;width:752px !important; height: 100%"
        ></dbAdapterRightLayer>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import procComm from '@/vue-caas/views/processnew/component/IconCommunication.vue';
import procMapper from '@/vue-caas/views/processnew/component/IconMapper.vue';
import procFilter from '@/vue-caas/views/processnew/component/IconFilter.vue';
import procConverter from '@/vue-caas/views/processnew/component/IconConverter.vue';
import procDir from '@/vue-caas/views/processnew/component/IconDir.vue';
import procDBAdapter from '@/vue-caas/views/processnew/component/IconDBAdapter.vue';
import procUser from '@/vue-caas/views/processnew/component/IconUser.vue';
import procTrig from '@/vue-caas/views/processnew/component/IconTrigger.vue';

// import { Drag, Drop } from "vue-drag-drop";
import { mapState } from 'vuex';
import validationUtils from '@/vue-caas/utils/validationUtils';
import Drawflow from 'drawflow';
import Vue from 'vue';
import vuetify from '@/plugins/vuetify';
import i18n from '@/locale';
import store from '@/store';
import styleDrawflow from 'drawflow/dist/drawflow.min.css'; // eslint-disable-line no-use-before-define
import EventBus from '@/vue-caas/views/process/component/event-bus.js';

import $ from 'jquery';
// 2021.12.06 SPKA-304 svg icon
import IconSvg from '@/vue-caas/components/IconBase.vue';
import cfg from '@/vue-caas/config/config.js';
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
import communicationRightLayer from '@/vue-caas/views/processnew/rightlayer/CommunicationRightLayer.vue';
import filterRightLayer from '@/vue-caas/views/processnew/rightlayer/FilterRightLayer.vue';
import mapperRightLayer from '@/vue-caas/views/processnew/rightlayer/MapperRightLayer.vue';
import triggerRightLayer from '@/vue-caas/views/processnew/rightlayer/TriggerRightLayer.vue';
import userRightLayer from '@/vue-caas/views/processnew/rightlayer/UserRightLayer.vue';
import folderRightLayer from '@/vue-caas/views/processnew/rightlayer/FolderRightLayer.vue';
import dbAdapterRightLayer from '@/vue-caas/views/processnew/rightlayer/DBAdapterRightLayer.vue';
import router from '@/router/index.js';

export default {
  components: {
    IconSvg,
    SystemProgress,
    communicationRightLayer,
    // filterRightLayer,
    mapperRightLayer,
    // triggerRightLayer,
    userRightLayer,
    // folderRightLayer,
    dbAdapterRightLayer,
  },
  procComm,
  procFilter,
  // procFolder,
  // procSet,
  procConverter,
  // procEnveloper,
  procMapper,
  procDir,
  procDBAdapter,
  procUser,
  // procTrig,
  // Drag,
  // Drop,
  name: 'process-detail-dialog',
  data() {
    return {
      prnrList: [],
      boundList: [
        { text: 'Inbound', value: 'I' },
        { text: 'Outbound', value: 'O' },
      ],
      editor: null,
      formData: {
        procId: '',
        procNm: '',
        compId: '',
        senderId: '',
        receiverId: '',
        procDirCd: '',
        procComList: [],
        selSenderId: '',
        selReceiverId: '',
        qlfrSenderEdiId: '',
        qlfrReceiverEdiId: '',
        comEdiNm: '',
        receiverEdiNm: '',
        senderEdiNm: '',
        comEdiId: '',
        senderEdiIdKey: '',
        receiverEdiIdKey: '',
      },
      formHasErrors: false,
      procComsColor: '',
      checkDialogColor: 'error',
      checkDialogInfo: '',
      title: '',
      options: '',
      replacePattern: [],
      nodeId: '',
      resetConverId: '',
      messageValidate: '',
      focusField: '',
      focusConverter: '',
      arrProc: [],
      loadArrProc: [],
      selectedNode: '',
      haveDir: false,
      mappers: [],
      senders: [],
      recipients: [],
      mapperContracts: [],
      listSender: [],
      listRecipient: [],
      selSenderId: {
        id: '',
      },
      selReceiverId: {
        id: '',
      },
      typeWorkflow: '',
      isHistory: true,
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      idenType: 0,
      // 05/27/2021 203737 SPKA-113 issue 27 Develop UI program of the "Folders" function
      leftItems: {
        header: ['USER_ID'],
        data: [
          {
            USER_ID: '',
          },
        ],
      },
      nodeDir: '',
      foldId: '',
      indexRoute: 0,
      alertMessage: '',
      focusDirIcon: true,
      currVersionNo: 0.1,
      applyCmt: '',
      apply_sts: '',
      // 2021.9.10 203728 SPKA-208 add Test/Live indicator
      processType: '',
      flatFileVersionHistoryItem: null,
      // 2021.10.19 203728 SPKA-224 add list params
      fltrTpCdList: [],
      cvtrTpCdList: [],
      protocolList: [],
      onSave: false,
      procIconSize: 16,
      isAgent: false,
      isLoading: true,
      nodesSelected: [],
      processViewArr: [],
      isClick: true,
      usedMapList: [],
      compTpNmList: [
        { text: 'Connector', value: 'COM' },
        { text: 'Filter', value: 'FLT' },
        { text: 'Folder', value: 'DIR' },
        { text: 'Mapper', value: 'MAP' },
        { text: 'Converter', value: 'CVT' },
        { text: 'User', value: 'USR' },
        { text: 'Trigger', value: 'TRIG' },
        { text: 'Group', value: 'GRP' },
        { text: 'DBAdapter', value: 'DBA' },
        { text: 'DBAdapter', value: 'DBAC' },
      ],
      rightLayerNmList: [
        { text: 'communicationRightLayer', value: 'COM' },
        { text: 'filterRightLayer', value: 'FLT' },
        { text: 'folderRightLayer', value: 'DIR' },
        { text: 'mapperRightLayer', value: 'MAP' },
        { text: 'converterRightLayer', value: 'CVT' },
        { text: 'userRightLayer', value: 'USR' },
        { text: 'triggerRightLayer', value: 'TRIG' },
        { text: 'groupRightLayer', value: 'GRP' },
        { text: 'dbAdapterRightLayer', value: 'DBA' },
        { text: 'dbAdapterRightLayer', value: 'DBAC' },
      ],
      authCompList: {
        COM: { manage: false },
        FLT: { manage: false },
        DIR: { manage: false },
        MAP: { manage: false },
        CVT: { manage: false },
        AI: { manage: false },
        USR: { manage: false },
        TRIG: { manage: true },
        GRP: { manage: false },
        DBA: { manage: false },
        DBB: { manage: false },
      },
    };
  },

  watch: {},

  computed: {
    getPrnrList() {
      return this.prnrList;
    },
    ...mapState('analysis', {
      fileViewWindowParam: 'fileViewWindowParam',
    }),
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
    communicationList() {
      return this.$store.getters.communicationSelectBoxList;
    },
    filterList() {
      return this.$store.getters.filterSelectBoxList;
    },
    converterList() {
      return this.$store.getters.dataSelectBox;
    },
    dbAdapterListHaveChild() {
      return this.$store.getters.dataDBASelectBox;
    },
    dbAdapterList() {
      let data = [];
      this.$store.getters.dataDBASelectBox.forEach((tmpDba) => {
        if (tmpDba.dba_type !== 'D2D' || tmpDba.dba_id === tmpDba.dba_child_id) {
          data.push(tmpDba);
        }
      });
      return data;
    },
    userList() {
      return this.$store.getters.userComponentSelectBoxList;
    },
    triggerList() {
      return this.$store.getters.triggerSelectBoxList;
    },
    compList() {
      let compList = [];
      const tmpCompList = this.$store.getters.companiesForSetup;
      for (let i = 0; i < tmpCompList.length; i += 1) {
        const tmpComp = tmpCompList[i];
        const tmp = { text: tmpComp.compNm, value: tmpComp.compId };
        compList.push(tmp);
      }
      // if (this.$cookies.get('ownr-id') === this.$cookies.get('comp-id')) {
      //   compList.unshift({ text: '*', value: '*' });
      // }
      return compList;
    },
    dbBrokerSelectBoxList() {
      return this.$store.getters.dbBrokerSelectBoxList;
    },
    foldList() {
      let data = [];
      this.$store.getters.foldList.forEach((e) => {
        if (e.FOLD_PA_ID === '0000000000' && e.FOLD_NAME === 'SYSTEM_' + e.FOLD_ID) {
          // this.systemFoldList.push(e);
        } else {
          data.push(e);
        }
      });
      return data;
    },
    ...mapState('map', {
      mapList: 'mapListSMLK',
    }),
  },

  async created() {
    const componentRouters = router.options.routes.filter((e) => e.meta && e.meta.compCd);
    const menuAuth = JSON.parse(this.$cookies.get('menu-auth'));
    componentRouters.forEach((route) => {
      const index = menuAuth.find((e) => e.h === route.path);
      if (index) {
        this.authCompList[route.meta.compCd].manage = index.m;
      }
    });
    this.$auth.manage = true;
    this.isAgent = cfg.isAgent;
    if (this.$route.query.theme === 'Dark') {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }

    let param = this.fileViewWindowParam[this.$route.params.id];
    this.options = param['options'];
    this.title = param['type'] + ' WorkFlow Group';
    this.typeWorkflow = param['type'];
    // 2021.9.10 203728 SPKA-208 add Test/Live indicator
    this.processType = param['type'];
    let currVersionNo = this.options.versionNo;
    if (currVersionNo) {
      this.currVersionNo = currVersionNo;
    }

    // 2021.10.20 203728 get some list from parent
    this.fltrTpCdList = param['fltrTpCdList'];
    this.cvtrTpCdList = param['cvtrTpCdList'];
    this.protocolList = param['protocolList'];
    EventBus.$on('collapse', this.updateConnections);
    EventBus.$on('set-comp-id', this.clickHandler);
    EventBus.$on('open-right-layer', this.openRightLayer);
    EventBus.$on('create-dba-child', this.createDBAChild);
    await this.initialize();
  },
  destroyed() {},
  // 2122.03.29 SPKA-421 Add spinner when loading Edit Workflow popup
  methods: {
    checkRightLayerDialog() {
      let check = false;
      let type = '';
      this.dialogs.forEach((val) => {
        this.rightLayerNmList.forEach((e) => {
          if (val.id === e.text + '_0') {
            check = true;
            type = e.text;
          }
        });
      });
      return { check, type };
    },
    loadComponents() {
      const id = document.getElementById('drawflow');
      this.editor = new Drawflow(id, Vue);
      let self = this;
      this.editor.on('nodeCreated', function(id) {
        self.nodeId = id;
      });
      this.editor.on('nodeSelected', function(id) {
        self.selectedNode = id;
        $(`#node-${id}`).removeClass('border-not-selected');
        $(`#node-${self.selectedNode}`).css({ 'z-index': '3' });
        $(`#node-${self.selectedNode}`).addClass('custom-border-drawflow_node');
      });
      this.editor.on('nodeUnselected', function() {
        $(`#node-${self.selectedNode}`).css({ 'z-index': '2' });
        $(`#node-${self.selectedNode}`).removeClass('custom-border-drawflow_node');
        self.selectedNode = '';
      });
      this.editor.start();
      this.editor.on('connectionCreated', function(obj) {
        if (this.isHistory)
          self.editor.removeSingleConnection(
            obj.output_id,
            obj.input_id,
            obj.output_class,
            obj.input_class,
          );
      });
      self.editor.on('clickEnd', (e) => {
        self.nodesSelected.forEach((eleN) => {
          const node = document.getElementById(`node-${eleN}`);
          if (node) node.classList.remove('selected');
        });
        self.nodesSelected = [];

        if (self.editor.node_selected !== null) {
          const nodeId = self.editor.node_selected.id.slice(5);
          let data = self.arrProc.filter((e) => e.nodeParent == nodeId);
          if (data.length > 0) {
            data.forEach((e) => {
              const node = document.getElementById(`node-${e.nodeId}`);
              node.classList.add('selected');
              self.nodesSelected.push(e.nodeId);
            });
          }
        }
      });

      self.editor.on('click', (e) => {
        if (
          e.target.className === 'proc-comp-name' ||
          e.target.parentElement.className === 'proc-comp-name'
        ) {
          const id = e.target.id;
          const nodeId = id.substring(0, id.length - 5);
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;

            if (comp.nodeId === nodeId) {
              comp.openRightLayer();
              return;
            }
          });
        }
        if (e.target.id === 'drawflow' || e.target.parentElement.id === 'drawflow') {
          if (self.checkRightLayerDialog().check) {
            const type = self.checkRightLayerDialog().type;
            if (self.$refs[type][0]) {
              setTimeout(() => {
                self.$refs[type][0].closeComDialog();
              }, 300);
            }
          }
        }
      });

      let last_x = 0;
      let last_y = 0;
      self.editor.on('mouseMove', ({ x, y }) => {
        if (self.editor.node_selected && self.editor.drag) {
          $('.cus-bg-dialog').addClass('hidden');
          $(`#${self.editor.node_selected.id}`).addClass('cursor-move');
          self.nodesSelected.forEach((eleN) => {
            if (eleN != self.editor.node_selected.id.slice(5)) {
              const node = document.getElementById(`node-${eleN}`);
              let xnew =
                ((last_x - x) * self.editor.precanvas.clientWidth) /
                (self.editor.precanvas.clientWidth * self.editor.zoom);
              let ynew =
                ((last_y - y) * self.editor.precanvas.clientHeight) /
                (self.editor.precanvas.clientHeight * self.editor.zoom);

              node.style.top = node.offsetTop - ynew + 'px';
              node.style.left = node.offsetLeft - xnew + 'px';

              // 2022.12.05 213960 change position of component name follow component position
              let div = document.getElementById(`node-${eleN}-icon`);
              if (div && div.style) {
                div.style.top =
                  parseInt(node.style.top.substring(0, node.style.top.length - 2)) + 53 + 'px';
                div.style.left =
                  parseInt(node.style.left.substring(0, node.style.left.length - 2)) - 100 + 'px';
              }

              self.editor.drawflow.drawflow[self.editor.module].data[eleN].pos_x =
                node.offsetLeft - xnew;
              self.editor.drawflow.drawflow[self.editor.module].data[eleN].pos_y =
                node.offsetTop - ynew;
              self.editor.updateConnectionNodes(`node-${eleN}`);
            }
          });
        }
        if (self.editor.node_selected && !self.editor.drag) {
          $(`#${self.editor.node_selected.id}`).removeClass('cursor-move');
          $('.cus-bg-dialog').removeClass('hidden');
        }
        const nodes = document.querySelectorAll(`.drawflow-node`);
        nodes.forEach((node) => {
          node.addEventListener('mouseover', () => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const comp = $(this)[0].__vue__.$parent;
              const id = comp.$el.parentElement.parentElement.id;
              if (id == node.id) {
                comp.showClose = true;
              }
            });
          });
          node.addEventListener('mouseleave', () => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const comp = $(this)[0].__vue__.$parent;
              const id = comp.$el.parentElement.parentElement.id;
              comp.showClose = false;
            });
          });
        });
        // 2022.12.05 213960 change position of component name follow component position
        if (self.selectedNode) {
          const id = self.selectedNode;
          let element = document.getElementById(`node-${id}`),
            style = window.getComputedStyle(element),
            top = style.getPropertyValue('top'),
            left = style.getPropertyValue('left');
          let div = document.getElementById(`node-${id}-icon`);
          if (div && div.style) {
            div.style.top = parseInt(top.substring(0, top.length - 2)) + 53 + 'px';
            div.style.left = parseInt(left.substring(0, left.length - 2)) - 100 + 'px';
          }
        }

        last_x = x;
        last_y = y;
      });
    },
    async openRightLayer(data) {
      const type = this.rightLayerNmList.filter((e) => e.value === data.comTp)[0].text;
      let item = {
        ROWID: 0,
        data: data,
        isHistory: this.isHistory,
      };
      if (this.checkRightLayerDialog().check) {
        await EventBus.$emit('check-right-layer-change');
        if (this.checkRightLayerDialog().check) {
          return;
        }
        this.newDialog(item, type) - 1;
        return;
      }
      this.newDialog(item, type) - 1;
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = 'Dialog ' + id;
      let options = {
        left: 30 * this.dialogId,
        top: 30 * this.dialogId + 20,
        item,
      };
      let companyId = '';
      switch (this.idenType) {
        case 0:
          companyId = this.formData.compId;
          break;
        case 1:
          companyId = 'C,' + this.formData.senderId;
          break;
        case 2:
          companyId = 'P,' + this.formData.receiverId;
          break;
      }
      return { id, name, type, options, companyId };
    },
    removeDialogPopup(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, 'left', obj.left);
      this.$set(this.dialogs[index].options, 'top', obj.top);
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    updateConnections(id) {
      this.editor.updateConnectionNodes(id.nodeId);
    },
    clickHandler(data) {
      let id = parseInt(data.nodeId.split('-').pop());
      for (let i = 0; i < this.arrProc.length; i += 1) {
        let info = this.arrProc[i].nodeId;
        if (info === id) {
          this.arrProc[i].comId = data.comId;
          $(`#node-${this.arrProc[i].nodeId}`).removeClass('border-invalid');
          $(`#node-${this.arrProc[i].nodeId}`).addClass('custom-border');
        }
      }
      // 2022.12.05 213960 add/change component name
      const compTpNm = this.compTpNmList.filter((e) => e.value === data.comTp)[0].text;
      if (!document.getElementById(`${data.nodeId}-icon`)) {
        if (!data.nodeId) {
          return;
        }
        let element = document.getElementById(data.nodeId),
          style = window.getComputedStyle(element),
          top = style.getPropertyValue('top'),
          left = style.getPropertyValue('left');
        let div = document.createElement('div');
        div.id = `${data.nodeId}-icon`;
        div.className = 'proc-comp-name';
        div.style.top = parseInt(top.substring(0, top.length - 2)) + 53 + 'px';
        div.style.left = parseInt(left.substring(0, left.length - 2)) - 100 + 'px';
        div.style.cursor = 'pointer';
        let p = document.createElement('p');
        if (!data.comId) {
          let name = document.createTextNode('Select ' + compTpNm + ' ..');
          p.appendChild(name);
          p.style.color = '#9AAAC3';
        } else {
          let name = document.createTextNode(data.comName);
          p.appendChild(name);
        }
        div.appendChild(p);
        element.after(div);
      } else {
        if (!data.comId) {
          $(`#${data.nodeId}-icon`).text('Select ' + compTpNm + ' ..');
          $(`#${data.nodeId}-icon`).css({ color: '#9AAAC3' });
        } else {
          $(`#${data.nodeId}-icon`).text(data.comName);
          $(`#${data.nodeId}-icon`).css({
            color: this.$vuetify.theme.dark ? '#FFFFFF' : '#000000',
          });
        }
      }
    },
    getPartnerList(data) {
      this.prnrList = [];
      this.prnrList.push({ text: '*', value: '*' });
      // When company select != *
      if (this.formData.compId !== '*') {
        for (let i = 0; i < this.compList.length; i += 1) {
          if (this.compList[i].value === this.formData.compId) {
            this.prnrList.push(this.compList[i]);
          }
        }
        this.$store.dispatch('getPartnerUseList').then(() => {
          const tmpPrnrList = this.$store.getters.partnerUseList;
          for (let i = 0; i < tmpPrnrList.length; i += 1) {
            const tmpPrnr = tmpPrnrList[i];
            const tmp = { text: tmpPrnr.prnrNm, value: tmpPrnr.prnrId };
            this.prnrList.push(tmp);
          }
        });
      }
    },
    async initialize() {
      // 2021.10.28 203728 add try catch
      this.isLoading = true;
      let leftItems = {
        header: ['USER_ID'],
        data: [
          {
            USER_ID: this.$cookies.get('user-id'),
          },
        ],
      };
      this.$store.dispatch('queryFolderList', leftItems).then(() => {
        this.foldList = this.$store.getters.foldList;
      });

      this.$store.dispatch('getDbBrokerList');

      // 2021.10.26 203728 SPKA-224 return data not get store
      this.$store.dispatch('getCvtrGrpList');

      this.$store.dispatch('getFilterSelectBoxList');

      this.$store.dispatch('getUserComponentSelectBoxList');

      // 2023.3.8 213979 SPKA-620 get data for DBA
      this.$store.dispatch('getDBAdapterList', {});

      await this.$store.dispatch('getCommunicationSelectBoxList');

      await this.$store.dispatch('getCompanyListSetup');

      if (this.options.dataValue !== undefined) {
        this.$store.dispatch('getWorkflowGroup', this.options.dataValue).then(async () => {
          const procInfo = this.$store.getters.workflowGroup;
          this.formData = procInfo;
          // this.formData.selSenderId = this.formData.selSenderEdiIdList;
          // this.formData.selReceiverId = this.formData.selReceiverEdiIdList;
          const params = {
            procId: this.options.dataValue,
            hash: this.$cookies.get('hash'),
          };

          // this.getPartnerList();
          // 2021.10.25 203728 SPKA-237 wait company EDI
          // await this.getSenderEdiId();
          // await this.getReceiverEdiId();
          await this.$store
            .dispatch('getWorkflowGroupDtlList', params)
            .then(() => {
              this.loadArrProc = this.$store.getters.workflowGroupDtlList;
              console.log('loadArrProc', this.loadArrProc);
            })
            // 2122.03.29 SPKA-421 Add spinner when loading Workflow popup
            .then(() => {
              this.loadComponents();
              this.$nextTick(() => this.updateComponent());
              this.isLoading = false;
            });
        });
      }
    },
    registerComponent(componentType, componentId, nodeInfo, mapperContract, useSrInMap) {
      const props = {
        comId: componentId,
        mapperContracts: mapperContract,
        listSender: this.listSender,
        listRecipient: this.listRecipient,
        listComId: this.arrProc,
        useSrInMap: useSrInMap,
        procDirCd: this.formData.procDirCd,
        isHistory: this.isHistory,
      };
      props.comId = componentId !== undefined ? componentId : '';

      const options = {
        store: store,
        i18n: i18n,
        vuetify: vuetify,
      };
      const procData = {
        comNm: '',
        comTp: componentType,
        comId: componentId,
        comInfo: '',
        nodeId: '',
        nodeInfo: nodeInfo,
      };
      // 2021.10.19 203728 SPKA-224 det data list
      switch (componentType) {
        case 'COM':
          procData.comNm = 'procComm';
          props.protocolList = this.protocolList;
          props.manage = this.authCompList.COM.manage;
          this.editor.registerNode(componentType, procComm, props, options);
          break;
        case 'MAP':
          procData.comNm = 'procMapper';
          props.manage = this.authCompList.MAP.manage;
          this.editor.registerNode(componentType, procMapper, props, options);
          break;
        case 'FLT':
          procData.comNm = 'procFilter';
          props.fltrTpCdList = this.fltrTpCdList;
          props.manage = this.authCompList.FLT.manage;
          this.editor.registerNode(componentType, procFilter, props, options);
          break;
        case 'CVT':
          procData.comNm = 'procConverter';
          props.cvtrTpCdList = this.cvtrTpCdList;
          props.manage = this.authCompList.CVT.manage;
          props.manageDBB = this.authCompList.DBB.manage;
          this.editor.registerNode(componentType, procConverter, props, options);
          break;
        case 'DIR':
          procData.comNm = 'procDir';
          this.editor.registerNode(componentType, procDir, props, options);
          break;
        case 'USR':
          procData.comNm = 'procUser';
          procData.comTp = 'USR';
          props.comTp = 'USR';
          props.setDisable = true;
          props.manage = this.authCompList.USR.manage;
          this.editor.registerNode(componentType, procUser, props, options);
          break;
        case 'DBA':
          procData.comNm = 'procDBAdapter';
          procData.nodeParent = nodeInfo.id;
          props.isDisable = true;
          props.manage = this.authCompList.DBA.manage;
          this.editor.registerNode(componentType, procDBAdapter, props, options);
          break;
        case 'DBAC':
          procData.comNm = 'procDBAdapterChild';
          procData.comTp = 'DBAC';
          procData.nodeParent = nodeInfo.data.nodeParent;
          props.isDisable = true;
          props.comId = componentId;
          props.comTp = 'DBAC';
          props.manage = this.authCompList.DBA.manage;
          this.editor.registerNode(componentType, procDBAdapter, props, options);
          break;
      }

      procData.nodeId = nodeInfo.id;
      this.arrProc.push(procData);
    },
    /* 203665 Load component saved in db */
    updateComponent() {
      /**
       * 2021.07.06 203737 SPKA-150 issue 98 Fix the no. 5. Start with DIR in "CLT_TestCase" sheet
       */
      if (this.loadArrProc.length > 0) {
        this.arrProc = [];
        let data = { drawflow: { Home: { data: {} } } };
        let number = 0;
        this.loadArrProc.map((e, i) => {
          let dta = JSON.parse(e.nodeInfo);
          data.drawflow.Home.data[dta.id] = dta;
          this.registerComponent(e.comTp, e.comId, dta, e.mapper_contract, e.use_sr_in_map);
          this.editor.addNodeImport(dta, this.editor.precanvas);
          if (number < dta.id) number = dta.id;
        });
        this.editor.nodeId = number + 1;
        this.editor.drawflow = data;
        this.$nextTick(() => {
          Object.values(data.drawflow.Home.data).map((item) => {
            this.editor.updateConnectionNodes('node-' + item.id);
          });
        });
      }
    },
    closeWindow(type) {
      const message = {
        message: type,
      };
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(message, '*');
      }

      setTimeout(() => {
        window.close();
      }, 50);
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
  },
  mounted() {
    window.addEventListener('storage', (event) => {
      if (event.key === 'processSharedData') {
        const updatedState = JSON.parse(event.newValue);
        let self = this;
        if (updatedState?.COM) {
          this.$store.dispatch('getCommunicationSelectBoxList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.communicationChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'COM') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex((e) => e.id == comp.formData.id);
                    if (index !== -1) {
                      comp.selectComm();
                      let indexArrDialog = self.findDialog('communicationRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.communicationRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex((e) => e.id == comp.formData.id);
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('communicationRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.communicationRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.FLT) {
          this.$store.dispatch('getFilterSelectBoxList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.filterChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'FLT') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex(
                      (e) => e.fltrId == comp.formData.fltrId,
                    );
                    if (index !== -1) {
                      comp.selectFilter();
                      let indexArrDialog = self.findDialog('filterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.filterRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex(
                      (e) => e.fltrId == comp.formData.fltrId,
                    );
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('filterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.filterRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.CVT) {
          this.$store.dispatch('getCvtrGrpList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.converterChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'CVT') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex(
                      (e) => e.cvtrId == comp.formData.cvtrId,
                    );
                    if (index !== -1) {
                      comp.selectConverter();
                      let indexArrDialog = self.findDialog('converterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.converterRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex(
                      (e) => e.cvtrId == comp.formData.cvtrId,
                    );
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('converterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.converterRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.DBA) {
          this.$store.dispatch('getDBAdapterList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.dbAdapterChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'DBA') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex(
                      (e) => e.dba_child_id == comp.formData.dba_child_id,
                    );
                    if (index !== -1) {
                      comp.selectDBADetail();
                      let indexArrDialog = self.findDialog('dbAdapterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.dbAdapterRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex(
                      (e) => e.dba_child_id == comp.formData.dba_child_id,
                    );
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('dbAdapterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.dbAdapterRightLayer[0].closeComDialog();
                      }
                    }
                  }
                } else if (comp.comTp == 'DBAC') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex(
                      (e) => e.dba_child_id == comp.formData.dba_child_id,
                    );
                    if (index !== -1) {
                      comp.selectDBADetail();
                      let indexArrDialog = self.findDialog('dbAdapterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.dbAdapterRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex(
                      (e) => e.dba_child_id == comp.formData.dba_child_id,
                    );
                    if (index !== -1) {
                      self.delNodeComponent(comp.nodeId);
                      let indexArrDialog = self.findDialog('dbAdapterRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.dbAdapterRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.USR) {
          this.$store.dispatch('getUserComponentSelectBoxList').then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.$store.getters.userComponentChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'USR') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex((e) => e.uc_id == comp.formData.uc_id);
                    if (index !== -1) {
                      comp.selectUser();
                      let indexArrDialog = self.findDialog('userRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.userRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex((e) => e.uc_id == comp.formData.uc_id);
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('userRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.userRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.MAP) {
          let masterSearchItems = {
            header: ['ADMIN_YN', 'CUST_ID'],
            data: [
              {
                ADMIN_YN: this.$cookies.get('user-admin-yn'),
                CUST_ID: this.$cookies.get('comp-id'),
              },
            ],
          };
          this.$store.dispatch('map/queryMapListByProcSetup', masterSearchItems).then(() => {
            $('.proc-component.v-card.v-sheet').each(function() {
              const dataChange = self.mapChange;
              if (
                Object.keys(dataChange).length > 0 &&
                (dataChange.update.length > 0 || dataChange.remove.length)
              ) {
                let comp = $(this)[0].__vue__.$parent;
                if (comp.comTp == 'MAP') {
                  if (dataChange.update.length > 0) {
                    let index = dataChange.update.findIndex((e) => e.MAP_PRCS_NO == comp.mapperId);
                    if (index !== -1) {
                      comp.selectMap();
                      let indexArrDialog = self.findDialog('mapperRightLayer_0');
                      if (indexArrDialog != null) {
                        self.dialogs[indexArrDialog].options.item.data = comp.formEmit;
                        self.$refs.mapperRightLayer[0].initialize();
                      }
                    }
                  } else {
                    let index = dataChange.remove.findIndex((e) => e.MAP_PRCS_NO == comp.mapperId);
                    if (index !== -1) {
                      comp.resetForm();
                      let indexArrDialog = self.findDialog('mapperRightLayer_0');
                      if (indexArrDialog != null) {
                        self.$refs.mapperRightLayer[0].closeComDialog();
                      }
                    }
                  }
                }
              }
            });
          });
        } else if (updatedState?.COMP) {
          this.$store.dispatch('getCompanyListSetup').then(() => {
            const dataChange = self.$store.getters.companyChange;
            if (Object.keys(dataChange).length > 0 && dataChange.remove.length > 0) {
              let index = dataChange.remove.findIndex((e) => e.value == this.formData.compId);
              if (index !== -1) {
                this.formData.compId = self.compList.filter((item) => item.value !== '*')[0].value;
              }
            }
          });
        } else if (updatedState?.PRNR) {
          const companyId = this.compList.filter((item) => item.value !== '*')[0].value;
          this.$store.dispatch('getPartnerUseList').then(() => {
            const dataChange = this.$store.getters.partnerChange;
            if (Object.keys(dataChange).length > 0) {
              if (dataChange.new.length > 0) {
                for (let i = 0; i < dataChange.new.length; i += 1) {
                  const tmpPrnr = dataChange.new[i];
                  const tmp = { text: tmpPrnr.prnrNm, value: tmpPrnr.prnrId };
                  this.prnrList.push(tmp);
                }
              } else if (dataChange.update.length > 0) {
                let indexSender = dataChange.update.findIndex(
                  (e) => e.prnrId == this.formData.senderId,
                );
                if (indexSender !== -1) {
                  this.formData.senderId = '';
                }
                let indexReceiver = dataChange.update.findIndex(
                  (e) => e.prnrId == this.formData.receiverId,
                );
                if (indexReceiver !== -1) {
                  this.formData.receiverId = '';
                }
                for (let i = 0; i < dataChange.update.length; i += 1) {
                  const tmpPrnr = dataChange.update[i];
                  let index = this.prnrList.findIndex((e) => e.value == tmpPrnr.prnrId);
                  if (index !== -1) {
                    const tmp = { text: tmpPrnr.prnrNm, value: tmpPrnr.prnrId };
                    this.prnrList.splice(index, 1, tmp);
                  }
                }
              } else if (dataChange.remove.length > 0) {
                let indexSender = dataChange.remove.findIndex(
                  (e) => e.prnrId == this.formData.senderId,
                );
                if (indexSender !== -1) {
                  this.formData.senderId = '';
                }
                let indexReceiver = dataChange.remove.findIndex(
                  (e) => e.prnrId == this.formData.receiverId,
                );
                if (indexReceiver !== -1) {
                  this.formData.receiverId = '';
                }
                for (let i = 0; i < dataChange.remove.length; i += 1) {
                  const tmpPrnr = dataChange.remove[i];
                  let index = this.prnrList.findIndex((e) => e.value == tmpPrnr.prnrId);
                  if (index !== -1) {
                    this.prnrList.splice(index, 1);
                  }
                }
              }
            }
          });
        }
      }
    });
  },
};
</script>
